var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/shipping/pdp-ship-restriction-icon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-alert\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" role=\"img\" aria-hidden=\"true\"><path d=\"M8.3 0.5c1.4 0.6 2.6 1.8 3.2 3.2C11.8 4.4 12 5.2 12 6c0 0.8-0.2 1.6-0.5 2.3 -0.6 1.4-1.8 2.6-3.2 3.2C7.6 11.8 6.8 12 6 12c-0.8 0-1.6-0.2-2.3-0.5 -1.4-0.6-2.6-1.8-3.2-3.2C0.2 7.6 0 6.8 0 6c0-0.8 0.2-1.6 0.5-2.3 0.6-1.4 1.8-2.6 3.2-3.2C4.4 0.2 5.2 0 6 0 6.8 0 7.6 0.2 8.3 0.5zM7.9 10.6c0.6-0.3 1.1-0.6 1.6-1.1 0.5-0.5 0.8-1 1.1-1.6 0.5-1.3 0.5-2.7 0-3.9C10.4 3.4 10 2.9 9.6 2.4 9.1 2 8.5 1.6 7.9 1.4c-1.2-0.5-2.6-0.5-3.9 0C3.5 1.6 2.9 2 2.4 2.4 2 2.9 1.6 3.4 1.4 4 0.9 5.3 0.9 6.7 1.4 8 1.6 8.6 2 9.1 2.4 9.6c0.5 0.5 1 0.8 1.6 1.1C5.3 11.2 6.7 11.2 7.9 10.6zM5.5 7.8v1.1h1V7.8L5.5 7.8 5.5 7.8zM5.5 3v3.4h1V3H5.5z\"/></svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/shipping/pdp-ship-restriction-icon.j2"] , dependencies)